import { BUTTON_INSPIRATIONAL_VARIANT } from '@fukku/button/Inspirational/constants'
import textActionM from '@fukku/styles/texts/textActionM.module.css'
import { cx } from 'classix'
import { useTransparentProps } from 'header-utils/context/TransparentPropsContext/useTransparentProps'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { TotalItems } from '../../TotalItems/TotalItems'
import styles from './ButtonLarge.module.css'

type ButtonLargeProps = {
	readonly handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void
	readonly iconRef: React.RefObject<HTMLDivElement | null>
}

export function ButtonLarge({ handleClick, iconRef }: ButtonLargeProps) {
	const { t } = useLabels()
	const { inspirationalVariant = BUTTON_INSPIRATIONAL_VARIANT.DEFAULT } =
		useTransparentProps()

	return (
		<button
			type='button'
			className={cx(
				styles.totalItemsContainer,
				inspirationalVariant && styles[inspirationalVariant]
			)}
			onClick={handleClick}
		>
			<div
				data-testid={'header.userMenu.cart.button'}
				className={cx(
					styles.text,
					styles.totalItemsText,
					textActionM.className
				)}
				ref={iconRef}
				tabIndex={-1}
			>
				<span>{t('header.shoppingBag.bag.text')}</span>
			</div>

			<div
				className={cx(
					styles.text,
					styles.totalItemsNumber,
					textActionM.className
				)}
			>
				<TotalItems withLabel />
			</div>
		</button>
	)
}
